module.exports = __webpack_public_path__ + "img/charUser.e3d3a665.png";